// src/components/reading/useStripeReturn.ts
import type { Deck } from "./backend/types";

export function parseStripeReturn(
  search: string,
): { sessionId: string; deck: Deck } | null {
  const params = new URLSearchParams(search);
  if (params.get("paid") !== "true") return null;
  const sessionId = params.get("session");
  const deck = params.get("deck");
  if (!sessionId) return null;
  if (deck !== "guidance" && deck !== "mediumship") return null;
  return { sessionId, deck };
}
